import { OrderType } from "../api/enums";

export const VALID_ORDER_TYPES = [
  OrderType.Limit,
  OrderType.Market,
  OrderType.Stop,
  OrderType.StopLimit
]